import "./_selectCustom.scss";

import cx from "classnames";
import {
  forwardRef,
  ReactElement,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import iconTrash from "@/assets/massification/iconTrash.svg";
import Button from "@/components/Button/Button";
import {OptionNameValue} from "@/ts/interface/formulaire";

interface SelectCustomProps {
  defaultValue: string;
  options: OptionNameValue[];
  name: string;
  disabled?: boolean;
  placeholder?: string;
  handleSelect: (value: any, libelle: any, complementData: any) => void;
  setValue?: (name: string, value: any) => void;
  watch?: (name: string) => any;
  label?: string;
  listIsAbsolute?: boolean; // Déclaration propre
  complementLabel?: string;
  onTrash?: () => void;
}

const SelectCustom = forwardRef<HTMLDivElement, SelectCustomProps>(
  function SelectCustom(
    {
      defaultValue,
      options,
      placeholder = "",
      disabled = false,
      handleSelect,
      setValue,
      watch,
      label,
      name,
      listIsAbsolute = true,
      complementLabel = "",
      onTrash,
    },
    ref,
  ): ReactElement {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const currentValue = watch
      ? watch(`${name}.libelle`) || defaultValue
      : defaultValue;

    const selectRef = useRef<HTMLDivElement>(null);
    // Permet à RHF d'utiliser le ref
    useImperativeHandle(ref, () => selectRef.current as HTMLDivElement);
    const optionsList = options.map((option, index) => {
      return (
        <li
          key={index}
          onClick={() => {
            setIsOpen(false);

            if (setValue) {
              console.log(name);
              setValue(`${name}.libelle`, option.libelle);
              setValue(`${name}.value`, option.value);
              setValue(`${name}.complementData`, option.complementData);
            }
            handleSelect(option.value, option?.libelle, option?.complementData);
          }}>
          {option.libelle}
          <span>{` ${option.complementLibelle || ""}`}</span>
        </li>
      );
    });

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent): void => {
        // Vérifie si on clique sur la scroll-bar.
        // On n'applique pas la fermeture du dropdown si c'est le cas.

        if (
          selectRef.current &&
          !selectRef.current.contains(event.target as Node) &&
          isOpen
        ) {
          setIsOpen(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return (): void => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen, selectRef]);
    const hasOption: boolean = optionsList.length > 0;
    const handleClick = (): void => {
      if (!disabled && hasOption) {
        setIsOpen(!isOpen);
      }
    };
    return (
      <div
        className={cx("selectCustom", disabled ? "disabled" : "")}
        ref={selectRef}
        tabIndex={0} // 👉 Rend focusable pour `shouldFocusError` de React Hook form
      >
        {label ? (
          <div className="selectCustom-labelBlock">
            <label htmlFor="">
              {label}
              <span>{` ${complementLabel}`}</span>
            </label>
            {onTrash && currentValue ? (
              <Button
                onClick={() => {
                  if (!disabled) onTrash();
                }}
                variant={`${disabled ? "disabled" : "secondary"} icon`}
                icon={iconTrash}
              />
            ) : null}
          </div>
        ) : null}
        <div
          className={cx(
            "selectCustom-current",
            hasOption ? "" : "selectCustom-noCliquable",
          )}
          onClick={handleClick}>
          <p>
            {currentValue || <span className="placeholder">{placeholder}</span>}
          </p>
          {hasOption ? (
            <div id="triangle-code" className={isOpen ? "" : "reverse"}></div>
          ) : null}
        </div>
        <ul
          className={cx(
            isOpen ? "" : "hidden",
            listIsAbsolute ? "absolute" : "",
          )}>
          {optionsList}
        </ul>
      </div>
    );
  },
);

export default SelectCustom;
